"use client";

var __jsx = React.createElement;
import React, { useState } from "react";
import useAfterInitEffect from "@lib/hooks/use-after-initialization-effect";
import { RadioGroup } from "@modules/shared/components/ui/radio-group";
import useCssModules from "@lib/hooks/use-css-modules";
import { cn } from "@lib/cn";
const UniqueSelectionInput = _ref => {
  var _cssModules$globals;
  let {
    options,
    onSelectOption = () => {},
    value = null,
    renderOptionsValue = null,
    renderOption = null,
    maxOptionsHeight = "none",
    label,
    renderHorizontal = false,
    disabled = false,
    required = false,
    dataTestId
  } = _ref;
  const {
    0: selectedOption,
    1: setSelectedOption
  } = useState(value);
  const {
    cssModules
  } = useCssModules();
  const labelClassName = cssModules === null || cssModules === void 0 || (_cssModules$globals = cssModules.globals) === null || _cssModules$globals === void 0 || (_cssModules$globals = _cssModules$globals.formBuilder) === null || _cssModules$globals === void 0 ? void 0 : _cssModules$globals.inputLabelClassName;
  useAfterInitEffect(() => {
    setSelectedOption(value);
  }, [value]);
  const handleValueChange = selectedValue => {
    const option = options.find(opt => String(opt.key) === selectedValue);
    if (option) {
      setSelectedOption(option);
      onSelectOption(option);
    }
  };

  // Transform Options to RadioOptions
  const radioOptions = options.map(option => {
    var _disabled;
    return {
      value: String(option.key),
      label: renderOptionsValue ? renderOptionsValue(option.value) : option.value,
      // honor per-option disabled (if present) with group-level fallback
      disabled: (_disabled = option === null || option === void 0 ? void 0 : option.disabled) !== null && _disabled !== void 0 ? _disabled : disabled
    };
  });

  // Custom renderOption handler that maps from RadioOption back to Option
  const handleRenderOption = renderOption ? (radioOption, index, radioElement) => {
    const originalOption = options[index];
    return renderOption(originalOption, index, radioElement);
  } : undefined;
  return __jsx("div", {
    className: cn("flex flex-col gap-1", disabled ? 'opacity-40' : '')
  }, label ? __jsx("div", {
    className: labelClassName
  }, label + (required ? " *" : "")) : null, __jsx("div", {
    className: "overflow-auto",
    style: {
      maxHeight: maxOptionsHeight
    }
  }, __jsx(RadioGroup, {
    options: radioOptions,
    value: selectedOption ? String(selectedOption.key) : "",
    onValueChange: handleValueChange,
    orientation: renderHorizontal ? "horizontal" : "vertical",
    disabled: disabled,
    required: required,
    disabledOpacity: 0.4,
    dataTestId: dataTestId,
    renderOption: handleRenderOption
  })));
};
export default UniqueSelectionInput;